<viewer-sidebar-container #rightSidebarContainer class="horizontal container" [disableClose]="true"
  (opened)="_onHorizontalSidebarOpened()" (closed)="_onHorizontalSidebarClosed()">
  <div class="sidebar" #sidebarTop position="top" data-mode="over">
    <viewer-header (drawingModeToggled)="onDrawingModeToggled($event)"
      (noteUrlClicked)="_onNoteUrlClicked($event)"></viewer-header>
  </div>

  <div class="sidebar-outer-wrapper wrapper">
    <viewer-sidebar-container #verticalSidebarContainer class="vertical" [immediate]="true" [disableClose]="true">
      <div class="sidebar-outer-wrapper">
        <!-- SIBF 구독 카운트 다운 -->
        <div class="sibf-box" *ngIf="expiredTime" [class.menu-opened]="_isMenuOpened">
          <div class="subscribe" *ngIf="!isExpired">
            <span>모아보기 중</span>
            <span>{{ expiredTime }}</span>
          </div>
          <div class="unsubscribe" *ngIf="isExpired">
            <span>모아보기 종료</span>
          </div>
        </div>
        <viewer-contents></viewer-contents>
        <viewer-page-number hide-when="invalid"></viewer-page-number>
        <viewer-pager [direction]="'left'"></viewer-pager>
        <viewer-pager [direction]="'right'"></viewer-pager>
        <viewer-fixedlayout-page-control></viewer-fixedlayout-page-control>
        <viewer-pushable-side-menu [position]="'bottom'">
          <viewer-language-selector></viewer-language-selector>
        </viewer-pushable-side-menu>
        <!-- <viewer-annotation-settings-fab
          (commentaryChanged)="_selectCommentary($event)"
        ></viewer-annotation-settings-fab> -->
        <viewer-drawing-tool-bar></viewer-drawing-tool-bar>
        <viewer-context-menu></viewer-context-menu>
        <viewer-loader [name]="'page'"></viewer-loader>
        <viewer-pushable-side-menu [position]="'bottom'" [isEnabledOn]="'mobile'">
          <viewer-page-back-button></viewer-page-back-button>
        </viewer-pushable-side-menu>
      </div>
    </viewer-sidebar-container>
    <div class="sidebar sidebar-mobile" #sidebarMobileBottom position="bottom" data-mode="over">
      <viewer-footer></viewer-footer>
    </div>
  </div>

  <div class="sidebar sidebar-desktop" #sidebarDesktopBottom position="bottom" data-mode="over">
    <viewer-footer></viewer-footer>
  </div>

  <div class="sidebar" #rightSidebar position="right" [class.mobile-bottom-sheet]="isMobile">
    <div class="bottom-sheet-handle" (touchstart)="onHandleTouchStart($event)" (touchmove)="onHandleTouchMove($event)"
      (touchend)="onHandleTouchEnd($event)">
      <span></span>
    </div>
    <viewer-right-panel></viewer-right-panel>
  </div>
</viewer-sidebar-container>

<viewer-pushable-side-menu [position]="'top'" [isEnabledOn]="'mobile'">
  <viewer-focused-member-popup></viewer-focused-member-popup>
</viewer-pushable-side-menu>

<viewer-fullscreen-loader>
  <div class="logo-loader">
    <div class="logo-b"></div>
    <div class="logo-u"></div>
    <div class="logo-k"></div>
  </div>
</viewer-fullscreen-loader>
<viewer-memo-popup></viewer-memo-popup>
<viewer-static-memo-popup></viewer-static-memo-popup>
